import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-smash-verification-code',
  templateUrl: './smash-verification-code.component.html',
  styleUrls: ['./smash-verification-code.component.scss']
})
export class SmashVerificationCodeComponent implements OnInit {

  @Input() isVerificationLoaded = false;
  @Input() isVerificationPending = false;
  @Input() isVerificationFailed = false;
  @Input() digits = 6;

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('otpInput') otpInputElement: ElementRef;

  validationCode: string;

  constructor() { }

  ngOnInit(): void { }

  private isDigitKey(event) {
    if (event?.key === 'Unidentified' || !event?.key) {
      const value = event?.target?.value;
      const lastValue = value?.charAt(value?.length - 1);
      if (lastValue) {
        return parseInt(lastValue) >= 0 && parseInt(lastValue) <= 9;
      }
    }
    return parseInt(event?.key) >= 0 && parseInt(event?.key) <= 9;
  }

  private isBackspaceKey(event) {
    return event.key === 'Backspace';
  }

  private isNumeric(value) {
    return /[0-9]|\./.test(value);
  }

  private isCtrlV(event: KeyboardEvent): boolean {
    return (event.ctrlKey || event.metaKey) && event.keyCode === 86;
  }

  private isDeleteKey(event) {
    return event.key === 'Delete';
  }

  onKeyup(event: KeyboardEvent): void {
    if (this.isDigitKey(event) || this.isCtrlV(event)) {
      if (this.validationCode?.toString().length === this.digits) {
        this.otpInputElement.nativeElement.blur();
      }
    } else if (this.isDeleteKey(event) || this.isBackspaceKey(event)) {
      // ok
    } else {
      event.returnValue = false;
      event.preventDefault();
    }
  }

  onKeydown(event: KeyboardEvent): void {
    if (this.isDigitKey(event) || this.isCtrlV(event)) {
      if (this.validationCode?.toString().length === this.digits) {
        event.returnValue = false;
        event.preventDefault();
      }
    } else if (this.isDeleteKey(event) || this.isBackspaceKey(event)) {
      // ok
    } else {
      event.returnValue = false;
      event.preventDefault();
    }
  }

  onFocus(event: FocusEvent): void {
    if (this.validationCode?.toString().length === this.digits) {
      this.otpInputElement.nativeElement.blur();
    }
  }

  onPaste(event: ClipboardEvent): void {
    if (event?.clipboardData?.getData('text/plain')) {
      const pastedText = event.clipboardData.getData('text/plain');
      const pastedDigits = pastedText.split('').slice(0, this.digits);
      if (pastedDigits.find(digit => !this.isNumeric(digit))) {
        event.returnValue = false;
        event.preventDefault();
        return;
      }
    }
  }

  onInput(event: InputEvent): void {
    const value = (event?.target as any).value;
    if (value?.length > this.digits) {
      this.validationCode = value.slice(0, this.digits);
    }
    if (this.validationCode?.toString().length === this.digits) {
      this.otpInputElement.nativeElement.blur();
      this.valueChange.emit(parseInt(this.validationCode));
    }
  }

  focus(): void {
    this.otpInputElement.nativeElement.focus();
  }

  get valid(): boolean {
    return this.validationCode?.toString().length === this.digits;
  }

  public reset(): void {
    this.validationCode = null;
  }
}
